import React from "react";
import AudioIcon from "../../assets/icons/white-audio.svg";
import "./index.less";

type AudioMiniPlayerProps = {
  width: number;
  height: number;
  borderRadius: number;
  onOpenModal: () => void;
  isPlayable?: boolean;
};

const AudioMiniPlayer: React.FC<AudioMiniPlayerProps> = ({ width, height, borderRadius, onOpenModal, isPlayable = false }) => {
  const handleClick = () => {
    if (isPlayable) {
      onOpenModal();
    }
  };

  return (
    <div
      className="audio-mini-player"
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#000000",
        borderRadius: borderRadius,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #333333",
        cursor: "pointer",
        position: "relative",
        padding: "4px",
        overflow: "hidden",
        zIndex: 10,
      }}
      onClick={handleClick}
    >
      <div className="icon-container">
        <img
          src={AudioIcon}
          alt="audio"
          style={{
            width: Math.min(width * 0.4, 24),
            height: Math.min(height * 0.4, 24),
            filter: "brightness(1.2)",
          }}
        />
      </div>
    </div>
  );
};

export default AudioMiniPlayer;
